<template>
  <div class="container-fluid">
    <div class="row mb-5" v-if="showHeader">
      <div class="col-8">
        <span class="display-4 col-12">{{ $t("COMMON.DETAILS") }}</span>
      </div>
    </div>

    <sales-delivery-view-details-sales-delivery-item-list
      :showHeader="showHeader"
      :salesDelivery="salesDelivery"
      @salesDeliveryItemsUpdated="salesDeliveryItemsUpdated"
    />
  </div>
</template>

<script>
import { Button, Tooltip } from "element-ui";
import SalesDeliveryViewDetailsSalesDeliveryItemList from "./SalesDeliveryViewDetailsSalesDeliveryItemList.vue";

export default {
  name: "sales-delivery-view-details",

  components: {
    SalesDeliveryViewDetailsSalesDeliveryItemList,
    [Tooltip.name]: Tooltip,
    [Button.name]: Button,
  },

  mixins: [],

  props: {
    showHeader: {
      default: true,
    },
    salesDelivery: {
      default: {},
    },
  },

  data() {
    return {};
  },

  computed: {},

  methods: {
    salesDeliveryItemsUpdated() {
      this.$emit("salesDeliveryItemsUpdated");
    },
  },

  mounted() {},

  watch: {},
};
</script>
